import GroupsIcon from '@mui/icons-material/Groups';
import { Grid, TextField, Typography } from '@mui/material';
import { ParticipantsConfiguration } from '@thro-types/modules-selections';

import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';
import { Course } from 'types/AppTypes';

interface Props {
  parConf: ParticipantsConfiguration;
  courses: Course[];
}

export const ParticipantConfiguration = ({ parConf, courses }: Props) => {
  const { t } = useTranslation();

  const selectedCourses = parConf.courseOfStudyIds.reduce((acc: string[], id) => {
    const course = courses.find(course => course.id === id);
    if (course) {
      acc.push(course.name);
    }
    return acc;
  }, []);

  return (
    <Grid item xs={12} container spacing={2}>
      <Grid item container spacing={2} xs={10}>
        <Grid item xs={12}>
          <Typography component="h3">
            {parConf.isGlobal
              ? t(
                  translations.pages.modules.create.prioritizationAndApproval.participantConfiguration.courseOfStudyIsGlobal()
                )
              : selectedCourses?.join(', ') ||
                t(translations.pages.modules.alerts.failedLoadingCourses())}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <TextField
            disabled
            size="small"
            focused={false}
            InputProps={{
              readOnly: true,
              style: {
                fontSize: 16
              }
            }}
            InputLabelProps={{
              style: {
                fontSize: 16
              }
            }}
            value={parConf.admissionCriteria.toString().replaceAll(',', ' ')}
            fullWidth
            label={t(
              translations.pages.modules.create.prioritizationAndApproval.participantConfiguration.admissionCriteria()
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            disabled
            size="small"
            style={{ cursor: 'default' }}
            focused={false}
            InputProps={{
              readOnly: true,
              style: {
                fontSize: 16
              }
            }}
            InputLabelProps={{
              style: {
                fontSize: 16
              }
            }}
            value={
              parConf.prioritization?.length
                ? parConf.prioritization.reduce((prev, current) => {
                    if (prev === '') {
                      return current.semester;
                    } else {
                      return prev + ' - ' + current.semester;
                    }
                  }, '')
                : ''
            }
            fullWidth
            label={t(
              translations.pages.modules.create.prioritizationAndApproval.participantConfiguration.prioritization()
            )}
          />
        </Grid>
      </Grid>
      {!!parConf.seats && (
        <Grid item xs={2}>
          <Grid
            container
            spacing={1}
            alignItems="center"
            justifyContent="center"
            className="moduleDetailView__moreInformation"
          >
            <Grid item>
              <GroupsIcon />
            </Grid>
            <Grid item>
              <Typography component="h4">
                {`${parConf.seats} ${t(
                  translations.pages.modules.create.prioritizationAndApproval.participantConfiguration.seats()
                )}`}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};
